export const workshop = [
  '99 Wahing Auto & Trading Sdn Bhd',
  'A Teck Auto Sdn. Bhd.',
  'A Teck Tyre & Enterprise - Desa Tebrau',
  'Advance Tyre Automart (PG) Sdn Bhd',
  'Aedee Mro Sdn Bhd',
  'Ah Ching Alignment Auto',
  'Aliff Smart Autoworks',
  'Almi Tyre Motorsport',
  'Ang Brothers Tyre N Auto Services Sdn Bhd',
  'Ang Trading & Motor Credit Sdn Bhd',
  'Apple Wheel Trading',
  'As Best Auto Sdn Bhd',
  'Aso Tyre Service Centre (M) Sdn Bhd',
  'Astar Tire & Service Centre',
  'AT Car Services',
  'Atlantic Auto Car Service',
  'Auto Champion Star',
  'Auto Mechanic Service Centre Sdn Bhd',
  'Autobac Sdn Bhd - Melodies',
  'Autopath Sdn Bhd',
  'AV Advance Tyre & Car Care Sdn Bhd',
  'AZ Autoworks (M) Sdn Bhd',
  'Banlihin Tyres & Batteries Sdn Bhd',
  'Banlihin Tyres & Battery Service Centre - Rosmerah',
  'Bao Liang Auto Car Care Centre Sdn Bhd',
  'Bengkel Membaiki Kenderaan Roseman',
  'Bens Performance',
  'Best Tyres Services Centre - Rosmerah 1/1',
  'BF Tyre Sdn Bhd',
  'BM Auto & Battery Centre',
  'Brilliant Tyre & Auto Service',
  'BRQ Tyre & Services Sdn. Bhd.',
  'Car Vision Auto Care Sdn Bhd',
  'CG Tyres Service',
  'Chee Heng Tyre Centre Sdn Bhd',
  'Chen Yee Tyre & Auto Sevice',
  'Cheng Ye Tyre And Battery Service',
  'Chiam Hing Tyres & Batteries (ME) Sdn Bhd',
  'Chin Hock & Son Tyre Services',
  'Chin Tat Tyre Service Centre Sdn Bhd',
  'Choo Hong Lian Kee',
  'Choo Huat Tyre & Battery Services',
  'Chop Eng Huat',
  'Chop Peng Huat',
  'Chop Swee Hoe',
  'Chop Teck Foong',
  'Chuan Tyre & Battery',
  'Chy Tyre & Autocare Centre',
  'City Tyre Trading - Pelangi',
  'CJ Tyre & Auto Service Sdn Bhd',
  'CM Tyre And Service Centre',
  'CNN Tyre & Services Sdn Bhd',
  'Crystal Auto Enterprise',
  'Dejaya Auto Supply Sdn Bhd',
  'Dek Huat Tyre Battery Sdn Bhd - Melaka',
  'DF Auto Parts (M) Sdn Bhd',
  'Distinction Automobile PLT',
  'Drivein Motor Sports Auto Service Centre Sdn Bhd',
  'Drivein Motor Sports Auto Service Centre Sdn Bhd -S.Hartamas',
  'DS Tyre And Battery Service Centre',
  'DTM Car Tech Auto Service Sdn Bhd',
  'E M A Tayar & Bateri',
  'Eco Plus Tyre Autocare',
  'Eco Sport Tyre Sdn Bhd',
  'Eco Tyre And Service Centre',
  'Eco Tyre Autocare (SP) Sdn Bhd',
  'EH Tyre & Auto Service Sdn Bhd',
  'EM Tyre & Auto Care',
  'Emkay Tyre Auto Services Sdn. Bhd.',
  'Empire Wheels Sdn Bhd',
  'Enco Auto Service',
  'Eng Hup Tyre & Batteries Services Centre - Mutiara Rini',
  'Eng Hup Tyre Service',
  'Era Maju Racing Wheels & Batteries Sdn Bhd - Gaya',
  'Euro Star Marketing Sdn Bhd',
  'Euroline Garage Service Centre',
  'Europres Motorsport (M) Sdn Bhd',
  'F & A Auto Care',
  'F & C Tyre Maintenance Sdn Bhd',
  'F Gear Tyre & Service Centre',
  'Fateh Tyre & Auto Sdn. Bhd.',
  'First Advantage Workshop Sdn Bhd',
  'Fly 7 Express Service',
  'Forged Wheel Auto',
  'G One Auto Care & Tyre Sdn. Bhd.',
  'GB Tyre Batteries Trading',
  'Gee Thye Tyre & Battery',
  'Goh Brothers Tyre & Battery Services',
  'Goh Swee Hin Marketing Sdn Bhd',
  'Gold Master Tyre & Auto Services',
  'Goldstar Wahing Tayar & Trading Sdn. Bhd.',
  'GRB Synergy Sdn Bhd',
  'GS Golden Speed Wheels & Tyre Service Sdn Bhd',
  'GT Tyres Motorsports',
  'H & D Tyre Enterprise',
  'H W Tyre And Auto Service Centre',
  'H Zone Car Care Auto Service Sdn. Bhd.',
  'H2 Tyres & Auto Services Sdn Bhd',
  'Hawk Tyre Service Sdn Bhd - Molek',
  'Hawk Tyre Service Sdn Bhd - Nusa Bestari',
  'Hawk Tyre Service Sdn Bhd-Aminah',
  'Hawk Tyre Service Sdn Bhd-Gaya',
  'Hawk Tyre Service Sdn Bhd-Pelangi',
  'Hawk Tyre Service Sdn Bhd-Rinting',
  'Hawk Tyre Service Sdn Bhd-Sentosa',
  'Hawk Tyre Service Sdn Bhd-Shell',
  'Hawk Tyre Service Sdn Bhd-Suria',
  'Hawk Tyre Service Sdn Bhd-Tampoi',
  'Hawk Tyre Service Sdn Bhd-Tebrau',
  'Heng Hong Tyre (Subang) Sdn. Bhd.',
  'Heng Hua Jaya Tyre & Battery',
  'HGH Tyre Centre',
  'HH Tyres & Wheels',
  'HI Grade Carcare Sdn Bhd',
  'Hiap Seng Tayar & Bateri',
  'High Power Auto Service Centre Sdn Bhd',
  'High Tech Auto Service Centre',
  'High Top Tyre Service (M) Sdn Bhd',
  'Hin Hin Tayar & Bateri',
  'HK Tyres & Services Centre Sdn. Bhd.',
  'HL Carcare Centre Sdn. Bhd.',
  'Hock Yee Hin Tyre',
  'Hoe Heng Tyre & Battery',
  'Hong Battery Tyres Service Center',
  'Hong Lee Tyre & Exhaust Service Centre',
  'Hong Seng Auto Service',
  'Hong Yung Tyre & Battery Services',
  'Hoo Tang Kee Tyre Service',
  'HT Truck Service Sdn Bhd - Gelang Patah',
  'Hup Li Tyre & Car Service',
  'Hup Seng Tyre And Rim Service Centre',
  'Hup Seng Tyres & Service Centre',
  'Hup Soon Auto Tyres (Puteri) Sdn Bhd',
  'Hup Soon Auto Tyres Sdn Bhd',
  'Hup Yik Workshop',
  'Hupshun Tyres Auto Car Care Sdn Bhd',
  'Hwa Tuck Tyre Auto Service Centre',
  'Hwa Xing Tayar Sdn Bhd',
  'HY Langkap Auto Service Center',
  'I Motorsports Sdn Bhd',
  'Ijan Tyre Service Centre',
  'Jach Tyre & Sport Rim Service Sdn. Bhd.',
  'Jaidon Motor Sdn Bhd',
  'Jakkai Trading',
  'Jam Tyre Battery Labu Services',
  'Janjigo Holdings Sdn Bhd',
  'Jaya Bintang Tyre & Services Sdn. Bhd.',
  'Jaya Tayar Dan Bateri',
  'JG Utek Trading - Jasin',
  'JL Tyres Services Center',
  'JM Garage Auto Service',
  'JP Tyre & Battery Service Centre',
  'JY Confidence Tyre & Car Service Sdn Bhd',
  'JY Top Auto Service Centre (M) Sdn. Bhd.',
  'Kar Master Auto Sdn Bhd',
  'KCS Tyre Auto Enterprise',
  'Kedai Tayar & Bateri Fei Loong',
  'Ken Fong Auto Care & Tyre Services',
  'Kent Tyre Service',
  'Keong Huang Tyre Servicing Sdn Bhd',
  'KH Tyre Molek Service Centre',
  'Kian Ann Car Service Centre',
  'Kim Heng Tyre Centre',
  'Kingdom Service Centre Sdn Bhd',
  'KNF Tyre & Car Care Service Sdn. Bhd.',
  'Kow Tong Tyre Trading',
  'KSS Service & Trading',
  'KT Advance Sdn Bhd',
  'Kuang Tyre Services',
  'L & B Tyres & Service Centre Sdn Bhd',
  'L & K Jaya Auto Tyre Services',
  'Era Maju Automobil – Adda Height ',
  'Era Maju Automobil – Johor Jaya',
  'Era Maju Automobil – Mount Austin',
  'Era Maju Automobil – Desa Jaya',
  'L.H. Autocare Tyres & Batteries (M) Sdn Bhd',
  'LCH Batteries & Tyres Sdn Bhd',
  'LCH Brothers Batteries & Tyre Sdn Bhd',
  'LD Borneo Tayar & Servis',
  'LF Auto Service Centre',
  'LHS Auto Services Sdn Bhd',
  'Li Seng Tyre & Battery Service Centre',
  'Lian Huat Tyres Sdn Bhd',
  'Lian Seng',
  'Lian Seng Service Centre Sdn Bhd',
  'Lian Xin Car & Tyre Service (M) Sdn Bhd',
  'Lias Tyre & Auto Sdn Bhd',
  'Lim Car Service & Tyre',
  'Little Boss Tyre Service Centre',
  'LM Tyre Auto Service Centre',
  'LMB Automobile Care Centre Sdn Bhd',
  'LMS Lian Hup Tyre',
  'Loo Autocare',
  'Loo Brothers Tyre Service Centre',
  'Loong Soon Tyres & Batteries',
  'Loong Tyre Service Centre Sdn Bhd',
  'Love Tyre Centre',
  'LSCC Auto Sdn Bhd',
  'LW Suspension Sdn Bhd',
  'M One Tyres & Motorsports',
  'M Pro Tyre & Services',
  'Majestic Auto Car Service Center',
  'Mans Integrated Sdn Bhd',
  'Mans Integrated Sdn Bhd',
  'Masai Tyre & Battery Sdn Bhd',
  'Master Ding Tyre & Repair Sdn Bhd',
  'Master Tyre Auto Service',
  'Masteroda Sdn Bhd',
  'Max Auto Services & Tyre',
  'Maximum Autocare Sdn Bhd',
  'Maxxx Motorsport',
  'MCO 2 Tyres & Service Sdn Bhd',
  'Meng Heng Tyres & Batteries Sdn Bhd',
  'Meng Tyre & Auto Service Center',
  'Meng Tyre & Battery Centre',
  'Meng Tyres Sdn Bhd - Muar',
  'Merit Autocare Sdn Bhd',
  'Ming Sheng Tyre Centre',
  'MJ Inter Sdn Bhd',
  'MM ST Tyre & Service Centre Sdn Bhd',
  'Motorway Tyres Sdn. Bhd.',
  'MS Expert Auto Center',
  'MTE Modern Tyre Sdn Bhd',
  'N A Tyres & Batteries Services',
  'NA Tyre Sdn Bhd',
  'Nam Seng Tayar & Bateri Sdn Bhd - Batu Pahat',
  'Nan Rong Automobile Services Sdn. Bhd.',
  'New Future Tyre Sdn Bhd',
  'New Soon Long Car Care',
  'Nova Autocare (PPS) Sdn. Bhd.',
  'Nova Autocare (SA) Sdn Bhd',
  'NS Soon Seng Tyre Auto Service Enterprise',
  'NYK Auto Service',
  'Oh Brothers Wheels Sdn Bhd',
  'Okai Pusat Servis Tayar dan Bateri',
  'One Stand Car Care Sdn Bhd',
  'One Tyre & Battery - Johor Jaya',
  'One Tyres Services',
  'OS Auto Service Centre (M) Sdn Bhd',
  'OS Tyres Pro Sdn Bhd',
  'Pang Tyres & Services Sdn. Bhd.',
  'Pengkalan Kubur Tyre Auto Service Centre',
  'Perfect One Tyre & Auto Service',
  'Perkhidmatan Tayar Dan Bateri Qi Shun',
  'Perniagaan Elektrik Bateri & Tayar Cemerlang',
  'Piau Joon Tyre Two Sdn Bhd',
  'Pit Stop Tyres Enterprise',
  'Pitwerkz Auto Service Sdn Bhd',
  'PJ Tyres & Sport Rim',
  'Posh Moments Sdn. Bhd.',
  'Public Auto Trading',
  'Pusat Servis Bateri & Tayar Wui',
  'Pusat Servis Kereta Dar Sing',
  'Pusat Servis Kereta Hong Seng - Dahlia',
  'Pusat Servis Tayar & Bateri Bersaudara',
  'Pusat Servis Tayar & Bateri Kim Sui',
  'Pusat Servis Tayar & Bateri Wilson WS',
  'Pusat Servis Tayar Dan Aksesori Kereta Ri Seng',
  'Pusat Servis Tayar Dan Bateri Maju Timur (P) Sdn Bhd',
  'Pusat Servis Tayar Karib Sdn Bhd',
  'Pusat Servis Tayar Kereta Dan Bateri Weng',
  'Pusat Servis Tayar Wei Soon',
  'Pusat Tayar & Servis Kereta Soon Meng Sdn Bhd',
  'Pusat Tayar Heng Long - Bukit Indah',
  'Pusat Tayar HKS',
  'Quick-Save Automart (M) Sdn. Bhd.',
  'Rabbit Tyre Auto Services',
  'Rainbow Green Tech Sdn Bhd',
  'Redline Asia Auto Services',
  'Rinting Wheel (M) Sdn Bhd - Molek',
  'RS Auto Service Centre',
  'RX Auto Car & Tyre Service Malaysia Sdn Bhd',
  'S Pro Wheels & Tyre Sdn Bhd',
  'S Two Onn Fatt Tyre Battery Service',
  'San Xing Auto Car Care',
  'San Xing Motorsports Sdn Bhd',
  'SB 31 Empire',
  'Seh Heng Tyre & Battery Sdn Bhd - Jln Kluang',
  'Semenyih Auto Sdn. Bhd.',
  'Setia Tyre Auto Service Centre Sdn Bhd',
  'SG Auto Aircond & Car Service Centre Sdn. Bhd.',
  'SG Auto Aircond & Car Service Centre Sdn. Bhd.',
  'SH Plus Tyre Sdn Bhd',
  'Shah Alam Tyres & Auto Accessories Sdn Bhd',
  'Sham Tyres And Car Services',
  'Sheng Zhun Tyre Sdn. Bhd.',
  'SHH Tyre Sdn Bhd - Labis',
  'Shi Heng Tyre & Battery Service Centre',
  'Shi May Trading Sdn Bhd',
  'SHJ Motor Sport Tyres And Battery',
  'SI Tyres Battery & Auto Service',
  'Silver Gear Sdn Bhd',
  'Sin Bee Soon Huat Auto Services Sdn Bhd',
  'Sin Hong Leong Tayar & Bateri Sdn Bhd',
  'Sing Heng Car Care',
  'Sing Lee Hin Tyre (M) Sdn Bhd',
  'Sithra Bumi Travel & Tours Sdn Bhd',
  'SK Tyre Motor Sport Enterprise',
  'Smart Auto Tyres & Battery Services Sdn Bhd - Melaka',
  'Smart Ser Auto Garage',
  'Smart Tyres Service Center - Kebun Teh',
  'Soon Aun Car Tayer Service Center',
  'Soon Hing Tyre Car Care Service Centre',
  'Soon Jaya Tayar & Servis Sdn Bhd',
  'Soon Jaya Tayar Sdn Bhd',
  'Soon Lee Heng Tyre Service',
  'Soon Lee Tyre & Battery Trading Sdn Bhd',
  'Soon Seng Tyres & Auto Sdn Bhd',
  'Soon Tyres Service Centre - Skudai',
  'Soon Yee Tyre Services',
  'Spec C Auto Service Sdn Bhd',
  'Speed One Tyre Service Sdn Bhd',
  'Speed Racing Tyres Auto Services Sdn. Bhd.',
  'Speed Seven Tyres Store Sdn Bhd',
  'Speed Tyre PD Sdn. Bhd.',
  'SS Pro Auto Sdn Bhd',
  'ST Wheels Tyre Sdn Bhd',
  'Sumec Auto Car Care Center Sdn Bhd',
  'Sun Hup Tyre Sdn Bhd',
  'Sunny Carcare Centre Sdn Bhd',
  'Super Auto Car Services',
  'Supermax Tyres & Auto Service Centre',
  'SW Advanced Auto Tyre Centre',
  'Syarikat Hing Seng Tyre Services',
  'Syarikat Lim Brothers Tyres Dan Bateri - Tasek',
  'Syarikat Lim Chin Hin',
  'Syarikat Tick Meng Tyre Dan Battery',
  'T Line Car Auto',
  'T.L. Tyres & Batteries Sdn Bhd',
  'Tahara Services',
  'Tai Hong Tyres & Sportrim Trading',
  'Tai Soon Tyre Sdn Bhd',
  'Tangkak Hiapheng Sdn Bhd',
  'Tayar Wah Sing Sdn Bhd',
  'TC Euro Cars Sdn Bhd',
  'Techniker Expert Sdn Bhd',
  'Techtunes Auto',
  'Teck Huat Tyres & Battery Sdn Bhd',
  'Tek Ming Auto Service Sdn Bhd',
  'TH Automotive Trading',
  'The Tyre Shop (M) Sdn. Bhd.',
  'Thiam Seong 168 Services',
  'Third Point (M) Sdn Bhd',
  'TKL Tyre & Rim Sdn Bhd',
  'TKS Tyre & Auto Service Centre',
  'TLC Power Star Car Service Centre Sdn. Bhd.',
  'TM Auto Tyre Service',
  'TMG Car Repair',
  'Tojo Car Centre',
  'Top City Car Service Centre Sdn Bhd',
  'Top City Tyre And Car Service Centre',
  'Top Q Tyres & Battery Services',
  'Top Win Automotive Services',
  'Top Year Auto Sdn Bhd',
  'Topspeed Automobile Sdn Bhd',
  'TRB Auto Car Care',
  'Tri Pacific Auto',
  'Trico 4 X 4 Auto Services',
  'Triple AE Motorsports Sdn Bhd',
  'Triumph Masters Marketing Sdn Bhd',
  'TS Auto Service Centre - Jalan Paya Terubong',
  'TS Smart Tyre',
  'TWM Tyre & Battery Trading',
  'Tyre App Sdn Bhd',
  'Tyre Base Service Centre Sdn Bhd',
  'Tyre City Service Centre',
  'Tyre Republic',
  'Tyreworld Motorsports (Johor) Sdn Bhd',
  'Uda Service Centre',
  'U-Liang Enterprise Sdn Bhd',
  'Ultimate Auto Care',
  'Uni Aircond & Tyre Services',
  'Union Tyre And Service Sdn Bhd',
  'VE Tech Tyres Service Centre',
  'Venus Tyres Car Service Enterprise',
  'Vitara Parts & Services Sdn Bhd',
  'VK Auto Service Centre',
  'VK Tyre Auto Services',
  'Vogue Motorsports Sdn Bhd',
  'V-Star Wahing Tayar & Trading Sdn Bhd',
  'Wai Seng Tyre & Battery Service',
  'Wang Lee Tyre & Battery',
  'Wawasan Sum Hup Sdn. Bhd.',
  'We And Wheels Services',
  'Weita Auto Service',
  'Weng Tat Tyre Service',
  'Win Star Tyre & Battery Centre',
  'Winsome Tyre & Battery Service Centre',
  'Wong Eong Tai Sdn Bhd',
  'WX Tyre & Auto Service Centre',
  'Xin Tai Tyre Sdn. Bhd.',
  'Y & D Auto Service Centre (M) Sdn Bhd',
  'Yau Lian Tyre Auto Service',
  'Yenta Trading Sdn Bhd',
  'Yoong Thai Enterprise Sdn Bhd',
  'Your Tyre Shop',
  'Yuda Tyre Service Center',
  'Yuen Chuan Huat Tyres & Batteries Sdn Bhd',
  'Yuz Wheel Services',
  'Zizep Enterprise',
  'Znos Tires & Services Enterprise',
  'Zone One Tyres & Auto Service',
  'ZX Auto Care',
  'Liang Tyre Services Centre',
]
